/* eslint-disable @typescript-eslint/no-explicit-any */
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { useUpdateTum } from 'app/react-query/hook/tradeUnionMember'
import dayjs from 'dayjs'
import { isEmpty, isEqual } from 'lodash'
import moment from 'moment'
import { useEffect, useRef } from 'react'
import { FormTumCommon, IFormCreateTradeUnionMember } from '../hook'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { PositionEnum } from '../../type'
import { isValidDateDDMMYYYY } from 'app/hook'

export const UpdateTumModal = ({
  tum,
  isReloadPage = false,
}: {
  tum?: ITradeUnionMember
  isReloadPage?: boolean
}) => {
  const { user } = useVerifyPermission()
  const modalRef = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<IFormCreateTradeUnionMember>()
  const { mutateAsync, isLoading } = useUpdateTum()

  const handleOpen = () => {
    modalRef.current?.open?.()
  }

  const handleSubmit = async (values: IFormCreateTradeUnionMember) => {
    if (!tum?.id) {
      return
    }

    if (!user?.member?.unit?.id) {
      notificationController.error({
        message: 'Bạn phải là đoàn viên và là quản lý của đơn vị này',
      })
      return
    }

    const res = await mutateAsync({
      ...values,
      id: tum?.id,
      chucVucongdoan: (values?.chucVucongdoan as unknown as string[]).join(','),
      ngaySinh: values?.ngaySinh?.format('DD/MM/YYYY'),
      ngayVaoUEH: values?.ngayVaoUEH?.format('DD/MM/YYYY'),
      ngayVaoCongDoan: values?.ngayVaoCongDoan?.format('DD/MM/YYYY'),
      ngayVaoDang: values?.ngayVaoDang?.format('DD/MM/YYYY'),
    })

    if (res) {
      modalRef.current?.hide?.()
      form?.resetFields()

      notificationController.success({
        message: 'Cập nhật đoàn viên thành công',
      })

      if (isReloadPage) {
        window.location.reload()
      }
    }
  }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chucVucongdoan = tum?.chucVucongdoan
      ?.split(',')
      ?.filter(itm => !isEmpty(itm?.trim())) as any

    form?.setFieldsValue({
      ...tum,
      chucVucongdoan: isEmpty(chucVucongdoan) ? [PositionEnum.DoanVien] : chucVucongdoan,
      unitId: tum?.unit?.id,
      ngaySinh: !isEmpty(tum?.ngaySinh) && isValidDateDDMMYYYY(tum?.ngaySinh)
        ? dayjs(moment(tum?.ngaySinh, 'DD/MM/YYYY').toDate())
        : undefined,
      ngayVaoUEH: !isEmpty(tum?.ngayVaoUEH) && isValidDateDDMMYYYY(tum?.ngayVaoUEH)
        ? dayjs(moment(tum?.ngayVaoUEH, 'DD/MM/YYYY').toDate())
        : undefined,
      ngayVaoCongDoan: !isEmpty(tum?.ngayVaoCongDoan) && isValidDateDDMMYYYY(tum?.ngayVaoCongDoan)
        ? dayjs(moment(tum?.ngayVaoCongDoan, 'DD/MM/YYYY').toDate())
        : undefined,
      ngayVaoDang: !isEmpty(tum?.ngayVaoDang) && isValidDateDDMMYYYY(tum?.ngayVaoDang)
        ? dayjs(moment(tum?.ngayVaoDang, 'DD/MM/YYYY').toDate())
        : undefined,
      schoolId: tum?.school?.id,
      activityEngagementId: tum?.activityEngagement?.id,
      degreeId: tum?.degree?.id,
    })
  }, [tum])

  const reset = () => {
    form?.resetFields()
  }

  return (
    <BaseModalComponent
      titleModal={`Cập nhật đoàn viên "${tum?.fullName}"`}
      handleSubmit={form?.submit}
      buttonOpenModal={
        <BaseButton onClick={handleOpen} type="text">
          {'Cập nhật đoàn viên'}
        </BaseButton>
      }
      isLoadingConfirm={isLoading}
      ref={modalRef}
      widthModal={900}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <FormTumCommon
            disableEditEmail={
              !(isEqual(tum?.email, 'cập nhật') || isEmpty(tum?.email))
            }
            reset={reset}
          />
        </BaseForm>
      }
    />
  )
}
